import { MenuFieldsProps, MenuLinkFieldProps } from '../components/HeaderMenu';
import { SubscriptionMode } from '../components/SubscriptionValidation';
import { getAPIAsyncCall } from '../dataFetcher/axiosMethodCalls';
import { getSubscriptionModeCookie } from './authHelper';

export async function getSubscriptionFileURL(
  productId: any,
  prodtype: any,
  language: any,
  edition: any
) {
  const subUrl = await getAPIAsyncCall(
    `${process.env.REACT_APP_CATALOG_URL}/catalog/subscription/${productId}/${prodtype}/download/${language}/${edition}`
  );

  if (subUrl && subUrl.data) {
    return subUrl.data.downloadUrl;
  }

  return subUrl || undefined;
}

export const openInNewTab = (url: string): void => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};

export function renderNavMenuItems(navItems: Array<MenuFieldsProps>, state: any) {
  const menuItems: { fields: MenuLinkFieldProps; displayName: string }[] = [];

  navItems.forEach((item) => {
    item.fields.Roles.forEach((role) => {
      switch (role.name) {
        case 'Retail':
          if (
            !menuItems.includes(item) &&
            getSubscriptionModeCookie() !== SubscriptionMode.Subscribed
          ) {
            menuItems.push(item);
          }
          break;
        case 'CustomerSubscriptionRep':
          if (
            state?.isSubscriptionRep &&
            !menuItems.includes(item) &&
            getSubscriptionModeCookie() === SubscriptionMode.Subscribed
          ) {
            menuItems.push(item);
          }
          break;
        case 'SubscribedUser':
          if (
            state?.isSubscribedUser &&
            !menuItems.includes(item) &&
            getSubscriptionModeCookie() === SubscriptionMode.Subscribed
          ) {
            menuItems.push(item);
          }
          break;
        default:
          break;
      }
    });
  });

  return menuItems;
}
